import { Box } from '@hivebrite/design-system/Box';
import { Skeleton } from '@hivebrite/design-system/Skeleton';

const GroupLoadingCard = () => (
  <Box
    height={{ _: 154, m: 156, l: 187, xl: 181 }}
    display="block"
    data-testid="group-thumbnail-skeleton"
  >
    <Skeleton height={80} width="100%" />
    <Box mt={2}>
      <Skeleton height={17} width="90%" />
    </Box>
  </Box>
);

export default GroupLoadingCard;
